"use strict";

var _require = require("./lib/global-monotonic-clock"),
    getGlobalMonotonicClockMS = _require.getGlobalMonotonicClockMS;

var _require2 = require("./lib/performance"),
    Performance = _require2.Performance;

var clockIsAccurate = require("./lib/clock-is-accurate");

module.exports = {
  Performance: Performance,
  getGlobalMonotonicClockMS: getGlobalMonotonicClockMS,
  clockIsAccurate: clockIsAccurate
};